var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c(
        "v-toolbar",
        { staticClass: "filters", attrs: { flat: "" } },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "primary", dark: "" },
              on: {
                click: function($event) {
                  _vm.dialog = true
                }
              }
            },
            [_vm._v("Add new Merch")]
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-text-field", {
            attrs: { "append-icon": "mdi-magnify", label: "Search" },
            model: {
              value: _vm.name,
              callback: function($$v) {
                _vm.name = $$v
              },
              expression: "name"
            }
          }),
          _vm._v(" "),
          _c("FilterMerch")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.dialog = false
                }
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { flat: "" } },
                    [
                      _c("v-toolbar-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v("New Merch")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "row",
                                  model: {
                                    value: _vm.valid,
                                    callback: function($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Name",
                                          rules: _vm.nameRules,
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.editedItem.name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.name"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Price",
                                          rules: _vm.priceRules,
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.editedItem.price,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "price",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.price"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.m_lOpts,
                                          required: "",
                                          dense: "",
                                          label: "M/L/Unisex"
                                        },
                                        model: {
                                          value: _vm.editedItem.m_l,
                                          callback: function($$v) {
                                            _vm.$set(_vm.editedItem, "m_l", $$v)
                                          },
                                          expression: "editedItem.m_l"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.colours,
                                          required: "",
                                          dense: "",
                                          label: "Colour"
                                        },
                                        model: {
                                          value: _vm.editedItem.colour,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "colour",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.colour"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.sizes,
                                          required: "",
                                          dense: "",
                                          label: "Size"
                                        },
                                        model: {
                                          value: _vm.editedItem.size,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "size",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.size"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Quantity",
                                          type: "number",
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.editedItem.qty,
                                          callback: function($$v) {
                                            _vm.$set(_vm.editedItem, "qty", $$v)
                                          },
                                          expression: "editedItem.qty"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue darken-1",
                            type: "submit",
                            disabled: !_vm.valid
                          },
                          on: { click: _vm.save }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.filteredMerch,
          "items-per-page": 50,
          search: _vm.name
        },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function($event) {
                        return _vm.edit(item)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { center: "" } }, [
                      _vm._v("mdi-pencil")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                item.qty <= 0
                  ? _c(
                      "v-btn",
                      {
                        attrs: { icon: "", small: "", color: "red" },
                        on: {
                          click: function($event) {
                            return _vm.deleteMerch(item.id)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { center: "" } }, [
                          _vm._v("mdi-delete-forever")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }